import React from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import { InputNumberMask } from '../../../../../../../../CommonComponents/OPL/Input/InputNumberMask';
import { FormFields } from '../../AccountForm.meta';
import { Box } from '../../../../../../../../CommonComponents/OPL/Box/Box';
import { Toggle } from '../../../../../../../../CommonComponents/OPL/Toggle/Toggle';
import { Label } from '../../../../../../../../CommonComponents/OPL/Label/Label';
import { useAccountFormContext } from '../../context/useAccountFormContext';
import { AccountModalUsageContext } from '../../context/AccountFormProvider.meta';

export const AnnuityPrincipalControl = () => {
  const { control, register } = useFormContext<FormFields>();
  const {
    options: { ShowAnnuityPreTaxToggle },
    usageContext,
  } = useAccountFormContext();

  if (usageContext === AccountModalUsageContext.AnnuityPurchaseWhatIf) {
    return null;
  }

  const inputId = 'bankAccount-AnnuityPrincipal';

  return (
    <Box>
      <Label htmlFor={`input--${inputId}`}>Cost Basis</Label>

      <Box
        css={`
          display: grid;
          grid-template-columns: 1fr auto;
          gap: 16px;
        `}
      >
        <Controller
          control={control}
          name="bankAccount.AnnuityPrincipal"
          render={({ field: { onChange, ...field } }) => (
            <InputNumberMask
              {...field}
              id={inputId}
              leftIcon="fa fa-dollar-sign"
              allowNegative={false}
              decimalScale={2}
              onValueChange={({ value }) => onChange(value ?? null)}
            />
          )}
        />

        {ShowAnnuityPreTaxToggle && (
          <Toggle {...register('bankAccount.AnnuityPretaxPrincipal')}>Pre-tax</Toggle>
        )}
      </Box>
    </Box>
  );
};
